<script lang="ts">
	import type { Snippet } from 'svelte';
	import Navbar from './Navbar.svelte';
	import Footer from './Footer.svelte';
	import PageBackground from './PageBackground.svelte';
	import GlitchEngine from './GlitchEngine.svelte';

	interface Props {
		background?: 'dots' | 'grid' | 'cyber' | 'none' | 'paper';
		children?: Snippet;
	}

	let { background = 'dots', children }: Props = $props();
</script>

<div class="site-layout">
	<GlitchEngine />
	<PageBackground variant={background} />
	<Navbar />
	<main class="site-layout__content">
		{@render children?.()}
	</main>
	<Footer />
</div>

<style lang="scss">
	.site-layout {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		&__content {
			flex: 1;
			padding-top: 70px;
		}
	}
</style>
